import { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

function useFetch(callback, dependencies = []) {
  const [loadingTable, setLoadingTable] = useState(true);
  const [error, setError] = useState();
  const [value, setValue] = useState();

  const callbackMemoized = useCallback(() => {
    setLoadingTable(true);
    setError(undefined);
    setValue(undefined);
    callback()
      ?.then(setValue)
      ?.catch(setError)
      ?.finally(() => setLoadingTable(false));
  }, dependencies);

  useEffect(() => {
    callbackMemoized();
  }, [callbackMemoized]);
  useEffect(() => {
    const errorHandler = (e) => {
      if (
        e.message === 'ResizeObserver loop limit exceeded' ||
        e.message === 'Script error.'
      ) {
        const resizeObserverErrDiv = document.getElementById(
          'webpack-dev-server-client-overlay-div',
        );
        const resizeObserverErr = document.getElementById(
          'webpack-dev-server-client-overlay',
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute('style', 'display: none');
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute('style', 'display: none');
        }
      }
    };

    window.addEventListener('error', errorHandler);
    return () => window.removeEventListener('error', errorHandler);
  }, []);
  return { loadingTable, error, value, reload: callbackMemoized };
}

useFetch.propTypes = {
  callback: PropTypes.func,
  dependencies: PropTypes.array,
};

export default useFetch;
